if (typeof debounce === "undefined") {
    function debounce(fn, wait) {
        let t;
        return (...args) => {
            clearTimeout(t);
            t = setTimeout(() => fn.apply(this, args), wait);
        };
    }
}
/**
 *  @class
 *  @function ThemeHeader
 */
if (!customElements.get("theme-header")) {
    class ThemeHeader extends HTMLElement {
        constructor() {
            super();
        }
        connectedCallback() {
            this.header_section = document.querySelector(".header-section");
            this.menu = this.querySelector("#mobile-menu");
            this.toggle = document.querySelector(".mobile-toggle-wrapper");
            this.toggleButton = this.toggle.querySelector(".mobile-toggle");
            this.dialog = this.querySelector("#mobile-menu-dialog");

            this.toggleButton.addEventListener(
                "click",
                this.openMobileMenu.bind(this),
            );
            this.dialog
                .querySelector(".mobile-menu-dialog--close")
                .addEventListener("click", this.closeMobileMenu.bind(this));
            // Escape: run the animated close instead of the instant native one.
            this.dialog.addEventListener("cancel", (e) => {
                e.preventDefault();
                this.closeMobileMenu();
            });
            // Taps outside the drawer (e.g. on the header above it) land on
            // the dialog itself and close the menu.
            this.dialog.addEventListener("click", (e) => {
                if (e.target === this.dialog) {
                    this.closeMobileMenu();
                }
            });
            window.addEventListener("resize", () => {
                if (this.dialog.open) {
                    this.setMobileMenuPosition();
                }
            });
            window
                .matchMedia("(min-width: 1068px)")
                .addEventListener("change", (e) => {
                    if (e.matches && this.dialog.open) {
                        this.closeMobileMenu(true);
                    }
                });

            // Sticky Header Class
            window.addEventListener("scroll", this.setStickyClass.bind(this), {
                passive: true,
            });
            // Mobile Menu offset
            window.addEventListener("scroll", this.setHeaderOffset.bind(this), {
                passive: true,
            });
            window.addEventListener("scroll", this.setHeaderHeight.bind(this), {
                passive: true,
            });

            window.dispatchEvent(new Event("scroll"));

            if (document.querySelector(".announcement-bar-section")) {
                window.addEventListener(
                    "scroll",
                    this.setAnnouncementHeight(),
                    {
                        passive: true,
                    },
                );
                window.dispatchEvent(new Event("resize"));
            }

            // Buttons.
            this.menu
                .querySelectorAll("summary")
                .forEach((summary) =>
                    summary.addEventListener(
                        "click",
                        this.onSummaryClick.bind(this),
                    ),
                );
            this.menu
                .querySelectorAll(".parent-link-back--button")
                .forEach((button) =>
                    button.addEventListener(
                        "click",
                        this.onCloseButtonClick.bind(this),
                    ),
                );
        }

        openMobileMenu() {
            if (this.dialog.open) {
                return;
            }
            this.setMobileMenuPosition();
            document.body.classList.add("overflow-hidden");
            // showModal() makes everything outside the dialog inert, so focus
            // and screen readers stay inside the menu until it is closed.
            this.dialog.showModal();
            // Force a reflow so the drawer transition runs after display changes.
            void this.dialog.offsetHeight;
            this.toggle.classList.add("active");
            window.dispatchEvent(new Event("resize.resize-select"));
        }
        closeMobileMenu(immediate = false) {
            if (!this.dialog.open || this.closingMobileMenu) {
                return;
            }
            this.closingMobileMenu = true;
            this.toggle.classList.remove("active");
            document.body.classList.remove("overflow-hidden");

            const finish = () => {
                this.closingMobileMenu = false;
                this.dialog.close();
                this.toggleButton.focus();
                window.dispatchEvent(new Event("resize.resize-select"));
            };
            // Keep the dialog open until the drawer transition (0.25s) ends.
            immediate ? finish() : setTimeout(finish, 250);
        }
        setMobileMenuPosition() {
            const toggleRect = this.toggleButton.getBoundingClientRect();
            const style = this.dialog.style;
            style.setProperty(
                "--mobile-menu-top",
                this.getBoundingClientRect().bottom + "px",
            );
            style.setProperty("--mobile-toggle-top", toggleRect.top + "px");
            style.setProperty("--mobile-toggle-left", toggleRect.left + "px");
            style.setProperty("--mobile-toggle-width", toggleRect.width + "px");
            style.setProperty(
                "--mobile-toggle-height",
                toggleRect.height + "px",
            );
        }
        setStickyClass() {
            if (this.classList.contains("header-sticky--active")) {
                let offset =
                    parseInt(this.getBoundingClientRect().top, 10) +
                    document.documentElement.scrollTop;
                this.classList.toggle(
                    "is-sticky",
                    window.scrollY >= offset && window.scrollY > 0,
                );
            }
        }
        setAnnouncementHeight() {
            const a_bar = document.getElementById(
                "shopify-section-announcement-bar",
            );
            if (a_bar) {
                let h = a_bar.clientHeight;
                document.documentElement.style.setProperty(
                    "--announcement-height",
                    h + "px",
                );
            }
        }
        setHeaderOffset() {
            let h = this.header_section.getBoundingClientRect().top;
            document.documentElement.style.setProperty(
                "--header-offset",
                h + "px",
            );
        }
        setHeaderHeight() {
            let h = this.clientHeight;
            document.documentElement.style.setProperty(
                "--header-height",
                h + "px",
            );
        }
        onSummaryClick(event) {
            const summaryElement = event.currentTarget;
            const detailsElement = summaryElement.parentNode;
            const parentMenuElement = detailsElement.closest(".link-container");
            const subMenuElement = detailsElement.querySelector(".sub-menu");

            if (this.querySelector(".parent-link-back--button")) {
                this.menu.scrollTop = 0;
            }

            let timeout = false;
            if (
                parentMenuElement &&
                parentMenuElement.classList.contains("submenu-open")
            ) {
                parentMenuElement.classList.remove("submenu-open");
                detailsElement.classList.remove("menu-opening");
                subMenuElement.style.maxHeight = "";
            } else {
                parentMenuElement &&
                    parentMenuElement.classList.add("submenu-open");
                detailsElement.classList.add("menu-opening");
                clearTimeout(timeout);
                timeout = setTimeout(() => {
                    subMenuElement.style.maxHeight =
                        subMenuElement.scrollHeight + "px";
                }, 10);
            }
        }
        onCloseButtonClick(event) {
            event.preventDefault();
            const detailsElement = event.currentTarget.closest("details");
            this.closeSubmenu(detailsElement);
        }
        closeSubmenu(detailsElement) {
            detailsElement.classList.remove("menu-opening");
            this.closeAnimation(detailsElement);
        }
        closeAnimation(detailsElement) {
            let animationStart;

            const handleAnimation = (time) => {
                if (animationStart === undefined) {
                    animationStart = time;
                }

                const elapsedTime = time - animationStart;

                if (elapsedTime < 400) {
                    window.requestAnimationFrame(handleAnimation);
                } else {
                    detailsElement.removeAttribute("open");
                }
            };

            window.requestAnimationFrame(handleAnimation);
        }
    }
    customElements.define("theme-header", ThemeHeader);
}
/**
 *  @class
 *  @function FullMenu
 */
if (!customElements.get("full-menu")) {
    class FullMenu extends HTMLElement {
        constructor() {
            super();
        }
        connectedCallback() {
            this.submenus = this.querySelectorAll(
                ".thb-full-menu>.menu-item-has-children:not(.menu-item-has-megamenu)>.sub-menu",
            );

            // Flag to prevent focusin from overwriting aria-expanded="false"
            // when Escape moves focus back to the trigger programmatically.
            let escaping = false;

            // aria-expanded management — must run before the submenus guard
            // so it covers mega-menu-only navigations too.
            this.querySelectorAll(
                ".thb-full-menu > .menu-item-has-children",
            ).forEach((item) => {
                const trigger = item.querySelector(
                    ":scope > .thb-full-menu--link",
                );
                if (!trigger) return;

                item.addEventListener("mouseenter", () => {
                    trigger.setAttribute("aria-expanded", "true");
                });
                item.addEventListener("mouseleave", () => {
                    trigger.setAttribute("aria-expanded", "false");
                });

                item.addEventListener("focusin", () => {
                    if (!escaping) {
                        trigger.setAttribute("aria-expanded", "true");
                    }
                });
                item.addEventListener("focusout", (e) => {
                    if (!item.contains(e.relatedTarget)) {
                        trigger.setAttribute("aria-expanded", "false");
                    }
                });
            });

            document.addEventListener("keydown", (e) => {
                if (e.key === "Escape") {
                    const focused = document.activeElement;
                    const parentItem =
                        focused &&
                        focused.closest(
                            ".thb-full-menu > .menu-item-has-children",
                        );
                    if (parentItem) {
                        const trigger = parentItem.querySelector(
                            ":scope > .thb-full-menu--link",
                        );
                        if (trigger) {
                            trigger.setAttribute("aria-expanded", "false");
                            if (focused === trigger) {
                                // Focus is on the trigger — blur it so :focus-within on the
                                // <li> is removed and the dropdown closes via CSS.
                                trigger.blur();
                            } else {
                                // Focus is inside the submenu — return it to the trigger.
                                // escaping flag prevents focusin from re-opening aria-expanded.
                                escaping = true;
                                trigger.focus();
                                escaping = false;
                            }
                        }
                    }
                }
            });

            // Sub-menu column repositioning only needed when regular (non-mega) submenus exist.
            if (!this.submenus.length) {
                return;
            }

            const _this = this;
            // resize on initial load
            window.addEventListener(
                "resize",
                debounce(function () {
                    _this.resizeSubMenus();
                }, 100),
            );

            window.dispatchEvent(new Event("resize"));

            document.fonts.ready.then(function () {
                _this.resizeSubMenus();
            });
        }
        resizeSubMenus() {
            this.submenus.forEach((submenu) => {
                let sub_submenus = submenu.querySelectorAll(
                    ":scope >.menu-item-has-children>.sub-menu",
                );

                sub_submenus.forEach((sub_submenu) => {
                    let w = sub_submenu.offsetWidth,
                        l =
                            sub_submenu.parentElement.parentElement.getBoundingClientRect()
                                .left +
                            sub_submenu.parentElement.parentElement
                                .clientWidth +
                            10,
                        total = w + l;
                    if (total > document.body.clientWidth) {
                        sub_submenu.parentElement.classList.add("left-submenu");
                    } else if (
                        sub_submenu.parentElement.classList.contains(
                            "left-submenu",
                        )
                    ) {
                        sub_submenu.parentElement.classList.remove(
                            "left-submenu",
                        );
                    }
                });
            });
        }
    }
    customElements.define("full-menu", FullMenu);
}
